import { IBonusPagesConfig } from "@finbackoffice/fe-core";
import { useBonusPagesConfig } from "@finbackoffice/site-core";
import ActiveLink from "components/base/active-link/ActiveLink";
import Translate from "components/base/translate/Translate";
import { FC, ReactNode, useCallback } from "react";
import { PROMO_REGISTRY_BY_PAGE } from "utils/constants/promoRegistry";
import styles from "./promotions-list.module.sass";

type IProps = {
    activeClassName?: string;
};

const PromotionsDefaultList: FC<IProps> = ({ activeClassName = styles.active }) => {
    const enabledBonusesConfig = useBonusPagesConfig();

    const renderLink = useCallback(
        ({ href, label, key }: { key: string; label: ReactNode; href: string }) => (
            <ActiveLink key={key} href={href} activeClassName={activeClassName}>
                <>{label}</>
            </ActiveLink>
        ),
        [activeClassName],
    );

    const renderPromotions = useCallback(
        (item: IBonusPagesConfig) => {
            const promo = PROMO_REGISTRY_BY_PAGE[item.name];

            if (!promo?.pageNameTid) {
                return null;
            }

            const content = renderLink({
                key: item.name,
                href: promo.href,
                label: <Translate tid={promo.pageNameTid} />,
            });

            return item.enable ? content : null;
        },
        [renderLink],
    );

    return <>{enabledBonusesConfig.map(renderPromotions)}</>;
};

export default PromotionsDefaultList;
